<script lang="ts">
	import type { Login, TwoFactorAuthVerify } from '../../../types/LoginTypes';
	import DefaultButton from '../../../basic/buttons/DefaultButton.svelte';
	import type { FlowContainerContext } from '../../../types/FlowContainerTypes';
	import DefaultTextInput from '../../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../../basic/input/InputLabel.svelte';
	import { handleStoreError } from '../../../stores/GeneralStore';
	import { getContext } from 'svelte';
	import { _ } from 'svelte-i18n';

	interface Props {
		targetLoginId: number;
		verifyFunction: (targetLoginId: number, request: TwoFactorAuthVerify) => Promise<void>;
	}

	let { targetLoginId, verifyFunction }: Props = $props();

	let { nextPage } = getContext<FlowContainerContext>('enzianFlowContainer');

	let request: TwoFactorAuthVerify = $state({
		code: ''
	});

	async function handleVerifyTwoFactorAuthCode() {
		try {
			//We have to set the information on the login store
			await verifyFunction(targetLoginId, request);

			//Go to the next page if the setup was a success
			nextPage();
		} catch (err) {
			handleStoreError('settings.admin.two_factor_auth.err_failed_to_verify', err);
		}
	}
</script>

<div class="flex flex-col gap-2">
	<!--Code-->
	<InputLabel label={$_('settings.admin.two_factor_auth.lbl_code')}></InputLabel>
	<DefaultTextInput
		propertyName=""
		bind:value={request.code}
		onKeyup={(e: KeyboardEvent) => {
			if (e.key == 'Enter') {
				handleVerifyTwoFactorAuthCode();
			}
		}}
	/>

	<!--Verify button-->
	<DefaultButton
		disabled={request.code.length < 6}
		text={$_('settings.admin.two_factor_auth.bt_verify')}
		spamProtectedCall={handleVerifyTwoFactorAuthCode}
	/>
</div>
